function MyvercoHomeController(){
	this.className			= "MyvercoHomeController";
	this.view				= false;
	this.glob				= ["/**/myverco/", "/**/myverco/?**", "/**/myverco/home**"];
	// this.glob			= ["/", "/?**"];
	this.viewData			= {};
}
// MyvercoHomeController.inheritsFrom( PageController );
MyvercoHomeController.inheritsFrom( StandardController );

MyvercoHomeController.prototype.swap = function(onComplete){
	this.$body				= $('body');
	this.$page				= this.$body.find('.js-page');
	this.$header			= this.$body.find('.js-page-header');

	this.animationControllers = [];

	return true;
}
MyvercoHomeController.prototype.on = function(onComplete){

	setTimeout(() => {
		this.setupAnimations();
		this.setupWordfallAnimation();
	},50);

	return true;
}
MyvercoHomeController.prototype.setupWordfallAnimation = async function(){
	if(this.matterAnimation) return;

	const xParentOffset = 0.5;
	const yParentOffset = (0.5 + -0.22);

	this.matterAnimation = animateMatter({
		selector: '.js-wordfall',
		settings: {
			bounds: {
				thickness: 100,
				bottom: {
					restitution: 0,
				}
			},

			object: {
				isStatic: true,
				friction: 0.1,
				frictionStatic: 100,
				frictionAir: 0.001,
				density: 0.001,
				mass: 0.005,
				inertia: 800,
				// angularDamping: 0.4,
				restitution: 1,

				render: {
					fillStyle: "transparent",
					strokeStyle: "red",
					lineWidth: 0,
				}
			}
		},
		objects: {
			// DESKTOP
			desktop: [{
				selector: "#wordfall-4", // Red
				//x: (parentRect.width * (0.5 + 0.00)) + (rect1.width / 100 * -25),
				//y: (parentRect.height * (0.5 + -0.25)) + (rect1.height / 100 * -120),
				x: -25,
				y: -120,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: -4.74,
				force: { x: -0.0002, y: -0.0002 }
			},{
				selector: "#wordfall-2", // Yellow
				x: 40,
				y: 55,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: 17.41,
				force: { x: -0.0002, y: -0.0002 }
			},{
				selector: "#wordfall-3", // Orange
				x: -65,
				y: 10,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: 2.1,
				force: { x: -0.0002, y: -0.0002 }
			},{
				selector: "#wordfall-1", // Green
				x: -36,
				y: 145,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: -11.61,
				force: { x: 0.0002, y: -0.0002 }
			},{
				selector: "#wordfall-0", // Blue
				x: 41,
				y: 230,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: 4.22,
				force: { x: 0.0002, y: -0.0002 }
			}],
			// MOBILE
			mobile: [{
				selector: "#wordfall-4", // Red
				x: -30,
				y: -160,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: -4.74
			},{
				selector: "#wordfall-2", // Yellow
				x: 32,
				y: -35,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: 17.41
			},{
				selector: "#wordfall-3", // Orange
				x: -30,
				y: 40,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: 2.1
			},{
				selector: "#wordfall-1", // Green
				x: -36,
				y: 164,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: -11.61
			},{
				selector: "#wordfall-0", // Blue
				x: 18,
				y: 270,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: 4.22
			}],
			// TABLET
			tablet: [{
				selector: "#wordfall-4", // Red
				x: -25,
				y: -100,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: -4.74
			},{
				selector: "#wordfall-2", // Yellow
				x: 40,
				y: 30,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: 17.41
			},{
				selector: "#wordfall-3", // Orange
				x: -65,
				y: 10,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: 2.1
			},{
				selector: "#wordfall-1", // Green
				x: -32,
				y: 120,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: -11.61
			},{
				selector: "#wordfall-0", // Blue
				x: 41,
				y: 215,
				xParentOffset: xParentOffset,
				yParentOffset: yParentOffset,
				rotate: 4.22
			}],
		},
		onPlay: ((object, Matter) => {
			const force = object?.force;

			if(force) {
				Matter.Body.applyForce(object.body, object.body.position, force);
			}
		})
		/*
		beforeUpdate: ((event, Matter) => {
			var engine = event.source;
		})
		*/
	});

	gsap.timeline({
		scrollTrigger: {
			trigger: '#wordfall-trigger',
			start: "top 50%",
			end: "top top",
			scrub: true,
			markers: false,
			toggleActions: "play restart play reverse",
			onEnter: (() => {
				if(this.matterAnimation) this.matterAnimation.play();
			}),
			onLeaveBack: (() => {
				// if(this.matterAnimation) this.matterAnimation.reset();
			}),
		}
	});
}

/*
MyvercoHomeController.prototype.setupShapeAnimation = function(){
	$('.y-shape').css('overflow', 'visible');

	const items1 = [];
	let anims = [{
		start: { x: `-1vh` },
	},{
		start: { x: `1vh` },
	},{
		start: { y: `-5vh` },
	},{
		start: { y: `-5vh` },
	},{
		start: { y: `-5vh` },
	},{
		start: { x: `+1vh` },
		// to: [{ x: 0, position: '>-1.5' }]
	},{
		start: { x: `-10vh` },
		// to: [{ x: 0, position: '>-1.5' }]
	},{
		start: { y: `-10vh` },
	}];

	let x = 0;
	for(let i = 7; i >= 0; i--) {
		x++;

		let item = {
			selector: `.myverco-home-1 .shape--desktop .y-shape path:nth-child(${i+1})`,
			start: { opacity: 0 },
			end: { x: 0, y: 0, opacity: 1 },
			options: {
				ease: 'power4.out',
				duration: 2,
				delay: 0.5 + 0.2 * x,
				// delay: 1 + 0.2,
			},
		}

		const anim = anims[i];
		if(anim?.options) item.options = { ...item.options, ...anim.options };
		if(anim?.start) item.start = { ...item.start, ...anim.start };
		if(anim?.end) item.end = { ...item.end, ...anim.end };
		if(anim?.to) item.to = anim.to;

		items1.push(item);
	}

	let t1 = new GsapController({
		containerSelector: ".myverco-home-1 .y-shape",
		triggerStart: 'top 90%',
		triggerEnd: 'top top',
		showMarkers: false,
		once: true,
		scrub: false,
		items: items1
	});



	const items2 = [];
	anims = [{
		start: { y: `-2vh` },
	},{
		start: { x: `2vh` },
	},{
		start: { x: `-2vh` },
	},{
		start: { x: `3vh` },
	},{
		start: { y: `-3vh` },
	},{
		start: { x: `3vh` },
	},{
		start: { x: `-5vh` },
	},{
		start: { y: `-5vh` },
	}];

	x = 0;
	for(let i = 7; i >= 0; i--) {
		x++;

		let item = {
			selector: `.myverco-home-2 .shape--desktop .y-shape path:nth-child(${i+1})`,
			start: { opacity: 0 },
			end: { x: 0, y: 0, opacity: 1 },
			options: {
				ease: 'power4.out',
				duration: 2,
				delay: 0.5 + 0.2 * x,
				// delay: 1 + 0.2,
			},
		}

		const anim = anims[i];
		if(anim?.options) item.options = { ...item.options, ...anim.options };
		if(anim?.start) item.start = { ...item.start, ...anim.start };
		if(anim?.end) item.end = { ...item.end, ...anim.end };
		if(anim?.to) item.to = anim.to;

		items2.push(item);
	}

	t1 = new GsapController({
		containerSelector: ".myverco-home-2 .y-shape",
		triggerStart: 'top 90%',
		triggerEnd: 'top top',
		showMarkers: false,
		once: true,
		scrub: false,
		items: items2
	});


	const items3 = [];
	anims = [{
		start: { x: `-1vh` },
	},{
		start: { y: `-2vh` },
	},{
		start: { y: `-5vh` },
	},{
		start: { x: `3vh` },
	},{
		start: { y: `-7vh` },
	},{
		start: { x: `7vh` },
	},{
		start: { x: `-10vh` },
	},{
		start: { y: `-10vh` },
	}];

	x = 0;
	for(let i = 7; i >= 0; i--) {
		x++;

		let item = {
			selector: `.myverco-home-3 .shape--desktop .y-shape path:nth-child(${i+1})`,
			start: { opacity: 0 },
			end: { x: 0, y: 0, opacity: 1 },
			options: {
				ease: 'expo.out',
				duration: 2,
				delay: 0.5 + 0.2 * x,
			},
		}

		const anim = anims[i];
		if(anim?.options) item.options = { ...item.options, ...anim.options };
		if(anim?.start) item.start = { ...item.start, ...anim.start };
		if(anim?.end) item.end = { ...item.end, ...anim.end };
		if(anim?.to) item.to = anim.to;

		items3.push(item);
	}

	t1 = new GsapController({
		containerSelector: ".myverco-home-3 .y-shape",
		triggerStart: 'top 90%',
		triggerEnd: 'top top',
		showMarkers: false,
		once: true,
		scrub: false,
		items: items3
	});

	const items4 = [];
	anims = [{
		start: { y: `-1vh` },
	},{
		start: { y: `-1vh` },
	},{
		start: { y: `-3vh` },
	},{
		start: { y: `-3vh` },
	},{
		start: { y: `-4vh` },
	},{
		start: { y: `-4vh` },
	},{
		start: { y: `-10vh` },
	},{
		start: { y: `-10vh` },
	}];

	x = 0;
	for(let i = 7; i >= 0; i--) {
		x++;

		let item = {
			selector: `.myverco-home-4 .shape--desktop .y-shape path:nth-child(${i+1})`,
			start: { opacity: 0 },
			end: { x: 0, y: 0, opacity: 1 },
			options: {
				ease: 'expo.out',
				duration: 2,
				delay: 0.5 + 0.1 * x,
			},
		}

		const anim = anims[i];
		if(anim?.options) item.options = { ...item.options, ...anim.options };
		if(anim?.start) item.start = { ...item.start, ...anim.start };
		if(anim?.end) item.end = { ...item.end, ...anim.end };
		if(anim?.to) item.to = anim.to;

		items4.push(item);
	}

	t1 = new GsapController({
		containerSelector: ".myverco-home-4 .y-shape",
		triggerStart: 'top 90%',
		triggerEnd: 'top top',
		showMarkers: false,
		once: true,
		scrub: false,
		items: items4
	});

	new AnimationController({
		containerSelector: ".myverco-home-0 .y-shape",
		triggerStart: 'top 90%',
		triggerEnd: 'top top',
		showMarkers: false,
		once: true,
		onScroll: false,
		scrub: true,
		items: [{
			selector: '.myverco-home-0 .shape--desktop .y-shape path',
			start: { opacity: 0.5 },
			end: { opacity: 1 },
			ease: 'power4.out',
			options: {
				duration: 1,
				stagger: (i) => {
					const staggerDelay = 0.3;
					const staggerDelays = [
						staggerDelay,     // Path 0
						staggerDelay * 5, // Path 1
						staggerDelay * 3, // Path 2
						staggerDelay * 4, // Path 3
						staggerDelay * 5, // Path 4
						staggerDelay * 2, // Path 5
						staggerDelay * 4, // Path 6
						staggerDelay * 5, // Path 7
					];

					return staggerDelays[i] || 0;
				}
			},
		},{
			selector: '.shape--mobile .y-shape path',
			start: { opacity: 0.5 },
			end: { opacity: 1 },
			ease: 'power4.out',
			options: {
				duration: 1,
				stagger: (i) => {
					const staggerDelay = 0.3;
					const staggerDelays = [
						staggerDelay,     // Path 0
						staggerDelay * 5, // Path 1
						staggerDelay * 3, // Path 2
						staggerDelay * 4, // Path 3
						staggerDelay * 5, // Path 4
						staggerDelay * 2, // Path 5
						staggerDelay * 4, // Path 6
						staggerDelay * 5, // Path 7
					];

					return staggerDelays[i] || 0;
				}
			},
		}]
	});
}
*/

MyvercoHomeController.prototype.setupAnimations = function(){

	const features = document.querySelectorAll('#features .js-feature-item');
	features.forEach((element, index) => {
		const mod = index % 2;
		const x = mod === 0 ? -50 : 50;
		const selector = '#features .js-feature-item:nth-child('+ (index + 1) +') .js-image--feature';

		// const t1 = gsap.timeline({
		// 	scrollTrigger: {
		// 		markers: false,
		// 		trigger: selector,
		// 		start: "top 80%",
		// 		end: "top top",
		// 		scrub: false,
		// 		once: true,
		// 	}
		// });
		//
		// t1.fromTo(
		// 	selector,
		// 	{ x: x, opacity: 0 },
		// 	{ x: 0, opacity: 1, duration: 1, ease: 'power4.out' }
		// );

		const t1 = new AnimationController({
			containerSelector: selector,
			triggerStart: 'top 80%',
			triggerEnd: 'top top',
			showMarkers: false,
			once: true,
			onScroll: false,
			scrub: true,
			items: [{
				selector: selector,
				start: { x: x, opacity: 0 },
				end: { x: 0, opacity: 1 },
				ease: 'power4.out',
				duration: 1
			}]
		});

		this.animationControllers.push(t1);
	});

	// const t2 = gsap.timeline({
	// 	scrollTrigger: {
	// 		markers: false,
	// 		trigger: this.$body.find('.js-feature2-item'),
	// 		start: "top 75%",
	// 		end: "top 50%",
	// 		scrub: false,
	// 		once: true,
	// 	}
	// });
	//
	// t2.fromTo(
	// 	this.$body.find('.js-feature2-item'),
	// 	{ opacity: 0 },
	// 	{ opacity: 1, duration: 0.5, stagger: 0.25 }
	// );

	const t2 = new AnimationController({
		containerSelector: '#features .js-feature2-item',
		triggerStart: 'top 75%',
		triggerEnd: 'top 50%',
		showMarkers: false,
		once: true,
		onScroll: false,
		scrub: true,
		items: [{
			selector: '#features .js-feature2-item',
			start: { opacity: 0 },
			end: { opacity: 1 },
			options: {
				duration: 0.5,
				stagger: 0.25
			}
		}]
	});

	this.animationControllers.push(t2);

	/*
	new AnimationController({
		containerSelector: '#purpose',
		triggerStart: 'top 50%',
		triggerEnd: 'top top',
		showMarkers: false,
		// once: true,
		onScroll: false,
		items: [{
			selector: '#purpose .js-image--shape-1 path:nth-child(1)',
			start: { x: -1.5, y: -1.5 },
			end: { x: 0, y: 0 },
		},{
			selector: '#purpose .js-image--shape-2 path:nth-child(2)',
			start: { x: -1.5, y: 1.5 },
			end: { x: 0, y: 0 },
		}]
	});

	new AnimationController({
		containerSelector: '#purpose',
		triggerStart: 'top 50%',
		triggerEnd: 'top top',
		showMarkers: false,
		// once: true,
		onScroll: false,
		items: [{
			selector: '#purpose .js-image--shape-2 path:nth-child(1)',
			start: { x: -1.5, y: -1.5 },
			end: { x: 0, y: 0 },
		},{
			selector: '#purpose .js-image--shape-2 path:nth-child(2)',
			start: { x: -1.5, y: 1.5 },
			end: { x: 0, y: 0 },
		},{
			selector: '#purpose .js-image--shape-2 path:nth-child(3)',
			start: { x: 1.5, y: 1.5 },
			end: { x: 0, y: 0 },
		}],
	});
	*/
}
MyvercoHomeController.prototype.off = function(){
	if(this.animationControllers) this.animationControllers.forEach((controller) => controller.destroy());

	if(this.matterAnimation) {
		this.matterAnimation.destroy();
		this.matterAnimation = false;
	}
}